var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article"}},[_c('vue-markdown',{attrs:{"source":_vm.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }